import ActionTypes from '../constants/ActionTypes';
import Dispatcher from '../core/Dispatcher';

export default {
  setUploadData: function(data, path) {
    Dispatcher.dispatch({
      type: ActionTypes.STEP_SET_UPLOAD_DATA,
      data: data,
      path: path
    });
  },

  setUploadId: function(id) {
    Dispatcher.dispatch({
      type: ActionTypes.STEP_SET_UPLOAD_ID,
      id: id,
    });
  },

  setHeight: function(height) {
    Dispatcher.dispatch({
      type: ActionTypes.STEP_SET_HEIGHT,
      height: height
    });
  },

  upload: function() {
    Dispatcher.dispatch({
      type: ActionTypes.STEP_UPLOAD
    });
  },

  convert: function() {
    Dispatcher.dispatch({
      type: ActionTypes.STEP_CONVERT
    });
  },

  download: function(id) {
    Dispatcher.dispatch({
      type: ActionTypes.STEP_DOWNLOAD,
      id: id
    });
  }
};



/** WEBPACK FOOTER **
 ** ./src/actions/StepsActionCreator.js
 **/